import cn from "../utils/cn"

const Loader = ({ className }) => (
  <div className="flex justify-center items-center">
    <div
      className={cn(
        "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-300",
        className
      )}
    ></div>
  </div>
)

export default Loader
